import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { StorePage } from 'src/app/pages/store/store.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { UserService } from '@shared/services/user.service';

import * as DateUtils from '@shared/utils/dateUtils';
import { UtilService } from '@shared/utils/util';
import { WebBlocker } from '../../decorators/web-blocker.decorator';


@Component({
  selector: 'app-vegboost-modal',
  templateUrl: './vegboost-modal.component.html',
  styleUrls: ['./vegboost-modal.component.scss'],
})
export class VegboostModalComponent {
  // Input para receber dados do componente pai
  @Input() userData: any;
  @Input() srcIconBoost: string = '';
  @Input() refreshMyData!: () => Promise<void>; 

  // Outputs para comunicação com o componente pai
  @Output() boostClicked = new EventEmitter<void>();
  @Output() purchaseClicked = new EventEmitter<string>();

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService,
              public userService: UserService,
              public toastCtrl: ToastController,
              public util: UtilService,
              private analytics: AnalyticsService,
  ) {}

  // Fechar modal
  dismiss() {
    this.modalCtrl.dismiss();
  }

  // Ação de boost
  boostMe() {
      let data = {
        dateStartClient: DateUtils.getDateToday(),
        dateEndClient: DateUtils.getDateTodayAddHour()
      }

      this.userService.postBoost(this.userData, data).subscribe((response) => {
        if (response.result) {
          this.util.presentToast(this.toastCtrl, "Você não possui cenouras suficientes.", 3000);
        } else {
          this.userData = JSON.parse(response);
  
          Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
            this.refreshMyData();
          });
  
        }
        this.dismiss();
      },
        err => {
          this.util.showToastUnableToConnect(this.toastCtrl);
          console.log('Error postRefreshMyData : ' + JSON.stringify(err));
        });
  }

  // Ação de compra
  @WebBlocker()
  async openCurrency(origin: string){
    this.purchaseClicked.emit(origin);

    let modal = this.modalCtrl.create({ component: StorePage, componentProps: { me: this.userData, type: "carrot", origin: origin } });
    this.analytics.registerEvent(AnalyticsService.carrots);
    this.analytics.registerEvent(AnalyticsService.crrtFromBoost);
    (await modal).present();
  }

  // Tratamento de erro da imagem
  onImageError(event: any) {
    console.error('Erro ao carregar imagem:', this.srcIconBoost);
    console.error('Evento de erro:', event);
  }

  }